module.exports = __webpack_public_path__ + "img/20190712164214YY截图20190711014426.05a9c1c2.png";